(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
      initRelatedProductsToggle();
      loadCollectionCarousel();
    }
  };
  request.send();
};

function initRelatedProductsToggle() {
  var section = document.querySelector('.related-products');
  if (!section) return;
  var toggles = section.querySelectorAll('.related-products__toggle');
  var panels = section.querySelectorAll('.related-products__view');
  if (toggles.length === 0) return;

  toggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var target = this.dataset.rpView;
      toggles.forEach(function(t) { t.classList.remove('related-products__toggle--active'); });
      panels.forEach(function(p) { p.classList.remove('related-products__view--active'); });
      this.classList.add('related-products__toggle--active');
      var panel = section.querySelector('[data-rp-panel="' + target + '"]');
      if (panel) panel.classList.add('related-products__view--active');
    });
  });
}

function loadCollectionCarousel() {
  var section = document.querySelector('.related-products');
  if (!section) return;
  var track = document.getElementById('rp-collection-track');
  if (!track) return;

  var vendor = section.dataset.productVendor;
  var collectionName = section.dataset.collectionName;
  var productId = section.dataset.productId;
  if (!vendor || !collectionName) return;

  var query = vendor + ' ' + collectionName;
  var searchUrl = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide';

  fetch(searchUrl)
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var products = data.resources && data.resources.results && data.resources.results.products;
      if (!products) { track.innerHTML = '<p style="font-size:0.85em;color:rgba(0,0,0,0.4);padding:12px 0">No other products found in this collection.</p>'; return; }

      var filtered = products.filter(function(p) {
        return p.vendor === vendor && String(p.id) !== productId;
      });

      if (filtered.length === 0) { track.innerHTML = '<p style="font-size:0.85em;color:rgba(0,0,0,0.4);padding:12px 0">No other products found in this collection.</p>'; return; }

      var html = '';
      filtered.forEach(function(p) {
        var imgSrc = p.image ? p.image.replace(/(\.\w+)$/, '_400x$1') : '';
        var priceFormatted = parseFloat(p.price).toLocaleString('en-CA', { style: 'currency', currency: 'CAD' });
        html += '<a class="related-products__card" href="' + p.url + '">';
        if (imgSrc) {
          html += '<img src="' + imgSrc + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" width="400" height="400">';
        } else {
          html += '<div style="aspect-ratio:1;background:rgba(0,0,0,0.04)"></div>';
        }
        html += '<div class="related-products__card-info">';
        html += '<div class="related-products__card-title">' + p.title + '</div>';
        html += '<div class="related-products__card-vendor">' + p.vendor + '</div>';
        html += '<div class="related-products__card-price">' + priceFormatted + '</div>';
        html += '</div></a>';
      });

      track.innerHTML = html;

      /* Add nav buttons */
      var carousel = track.closest('.related-products__carousel');
      if (!carousel || filtered.length <= 4) return;

      var prevBtn = document.createElement('button');
      prevBtn.className = 'related-products__nav related-products__nav--prev';
      prevBtn.setAttribute('aria-label', 'Previous');
      prevBtn.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>';

      var nextBtn = document.createElement('button');
      nextBtn.className = 'related-products__nav related-products__nav--next';
      nextBtn.setAttribute('aria-label', 'Next');
      nextBtn.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="9 6 15 12 9 18"/></svg>';

      carousel.appendChild(prevBtn);
      carousel.appendChild(nextBtn);

      var cardW = track.querySelector('.related-products__card').offsetWidth + 16;
      function updateNav() {
        prevBtn.disabled = track.scrollLeft <= 5;
        nextBtn.disabled = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 5;
      }
      prevBtn.addEventListener('click', function() { track.scrollBy({ left: -cardW * 2, behavior: 'smooth' }); });
      nextBtn.addEventListener('click', function() { track.scrollBy({ left: cardW * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', updateNav);
      updateNav();
    })
    .catch(function() {
      track.innerHTML = '<p style="font-size:0.85em;color:rgba(0,0,0,0.4);padding:12px 0">Could not load collection products.</p>';
    });
}

document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
